import { fetcher } from '../utils'
import { ComponentInfoClientLinkVO, ComponentInfoLinkVO } from '@repo/types'

export default async (input: ComponentInfoClientLinkVO): Promise<ComponentInfoLinkVO> => {
  return await fetcher(`/api/componentInfo/client/link`, 'POST', input)
}
